import { TicketStatusAliasMap } from "@constant/ticket-status-mapper.constant";
import { BetTicketStatus } from "@enum/ticket-status.enum";

export function normalizeBetTicketStatus(
  rawStatus: string | null | undefined
): BetTicketStatus | null {
  if (!rawStatus) {
    return null;
  }

  const normalizedKey = rawStatus.trim().toLowerCase();
  const statusMap = TicketStatusAliasMap[normalizedKey];
  if(statusMap) {
    return statusMap;
  }

  return null;
}
